<app-navbar-style-two></app-navbar-style-two>

<!-- Custom Toast Overlay -->
<div class="custom-toast" [class.show]="toast.show" [class.success]="toast.type === 'success'" [class.error]="toast.type === 'error'" [class.warning]="toast.type === 'warning'">
  <i class="bx" [class.bx-check-circle]="toast.type === 'success'" [class.bx-x-circle]="toast.type === 'error'" [class.bx-info-circle]="toast.type === 'warning'"></i>
  <span class="toast-message">{{toast.message}}</span>
</div>

<div class="profile-wrapper">
  
  <div class="profile-header-section">
    <h2 class="page-title">My Account</h2>
    <p class="page-subtitle">Manage your profile details, check past orders, and configure account security.</p>
  </div>

  <!-- Custom Navigation Tabs -->
  <div class="profile-tabs-container">
    <ul class="custom-tabs">
      <li class="tab-item" [class.active]="activeTab === 'profile'" (click)="activeTab = 'profile'">
        <i class="bx bx-user tab-icon"></i>
        <span class="tab-label">Profile Info</span>
      </li>
      <li class="tab-item" [class.active]="activeTab === 'orders'" (click)="activeTab = 'orders'">
        <i class="bx bx-shopping-bag tab-icon"></i>
        <span class="tab-label">My Orders</span>
      </li>
      <li class="tab-item" [class.active]="activeTab === 'password'" (click)="activeTab = 'password'">
        <i class="bx bx-shield-quarter tab-icon"></i>
        <span class="tab-label">Security</span>
      </li>
    </ul>
  </div>

  <div class="tab-content-wrapper mt-4">

    <!-- Loading Overlay -->
    <div *ngIf="isLoadingProfile" class="loading-overlay">
      <div class="spinner"></div>
      <p>Loading your account details...</p>
    </div>

    <!-- PROFILE TAB -->
    <div *ngIf="activeTab === 'profile' && !isLoadingProfile" class="animate-fade-in">
      <div class="profile-dashboard-grid">
        
        <!-- Profile Card -->
        <div class="dashboard-card profile-card-info">
          <!-- <div class="profile-card-header">
            <div class="avatar-wrapper">
              <div class="avatar">{{ user_profile.name?.charAt(0) || 'U' }}</div>
              <div class="avatar-badge"><i class="bx bx-camera"></i></div>
            </div>
            <div class="profile-user-summary">
              <h3>{{ user_profile.name || 'User Profile' }}</h3>
              <span class="user-badge">Customer Account</span>
            </div>
          </div> -->

           <div class="profile-header-premium">
            <div class="avatar-wrapper" (click)="fileInput.click()" title="Click to change profile picture">
              <img *ngIf="user_profile.profile_image" [src]="user_profile.profile_image" class="avatar-img" alt="Profile Picture">
              <div *ngIf="!user_profile.profile_image" class="avatar-text">{{ user_profile.name?.charAt(0) || 'U' }}</div>
              <div class="avatar-badge" [class.uploading]="isUploadingImage">
                <i *ngIf="!isUploadingImage" class="bx bx-camera"></i>
                <span *ngIf="isUploadingImage" class="avatar-spinner"></span>
              </div>
              <input type="file" #fileInput (change)="triggerImageUpload($event)" accept="image/*" style="display: none;">
            </div>
            </div>

          <div class="profile-card-body">
            <div class="detail-item">
              <i class="bx bx-envelope detail-icon"></i>
              <div class="detail-text">
                <span class="detail-label">Email Address</span>
                <span class="detail-val">{{ user_profile.email || 'Not provided' }}</span>
              </div>
            </div>
            <div class="detail-item">
              <i class="bx bx-phone detail-icon"></i>
              <div class="detail-text">
                <span class="detail-label">Mobile Number</span>
                <span class="detail-val">{{ user_profile.mobile || 'Not provided' }}</span>
              </div>
            </div>
          </div>

          <div class="profile-card-footer" *ngIf="!editMode">
            <button class="btn-profile-edit" (click)="toggleEditMode(true)">
              <i class="bx bx-edit-alt"></i> Edit Profile
            </button>
          </div>
        </div>

        <!-- Stats Panel -->
        <div class="stats-panel" *ngIf="!editMode">
          <h4 class="section-title-small">Activity Overview</h4>
          
          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon-wrapper orders">
                <i class="bx bx-package"></i>
              </div>
              <div class="stat-data">
                <span class="stat-val">{{ stats.total_orders || 0 }}</span>
                <span class="stat-lbl">Total Orders</span>
              </div>
            </div>

            <div class="stat-card">
              <div class="stat-icon-wrapper spent">
                <i class="bx bx-dollar"></i>
              </div>
              <div class="stat-data">
                <span class="stat-val">{{ (stats.total_spent || 0) | number:'1.2-2' }}</span>
                <span class="stat-lbl">Total Spent</span>
              </div>
            </div>

            <div class="stat-card full-width-stat">
              <div class="stat-icon-wrapper last-order">
                <i class="bx bx-calendar"></i>
              </div>
              <div class="stat-data">
                <span class="stat-val">{{ stats.last_order ? (stats.last_order | date:'mediumDate') : 'No orders yet' }}</span>
                <span class="stat-lbl">Last Order Date</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Edit Form -->
        <div *ngIf="editMode" class="dashboard-card edit-profile-form">
          <div class="form-header">
            <h4>Update Profile Settings</h4>
            <p>Modify your contact details. Changes are updated immediately across your session.</p>
          </div>

          <form (ngSubmit)="updateProfile()" class="custom-form">
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label-custom">Full Name</label>
                <div class="input-icon-wrapper" [class.error]="profileErrors.name">
                  <i class="bx bx-user input-icon"></i>
                  <input type="text" [(ngModel)]="profile.name" name="name" class="form-control-custom" placeholder="Enter Full Name">
                </div>
                <span class="field-error" *ngIf="profileErrors.name">{{ profileErrors.name }}</span>
              </div>

              <div class="col-md-12 mb-3">
                <label class="form-label-custom">Email Address</label>
                <div class="input-icon-wrapper" [class.error]="profileErrors.email">
                  <i class="bx bx-envelope input-icon"></i>
                  <input type="email" [(ngModel)]="profile.email" name="email" class="form-control-custom" placeholder="Enter Email Address">
                </div>
                <span class="field-error" *ngIf="profileErrors.email">{{ profileErrors.email }}</span>
              </div>

              <div class="col-md-12 mb-3">
                <label class="form-label-custom">Mobile Number</label>
                <div class="input-icon-wrapper" [class.error]="profileErrors.mobile">
                  <i class="bx bx-phone input-icon"></i>
                  <input type="text" [(ngModel)]="profile.mobile" name="mobile" class="form-control-custom" placeholder="Enter Mobile Number">
                </div>
                <span class="field-error" *ngIf="profileErrors.mobile">{{ profileErrors.mobile }}</span>
              </div>
            </div>

            <div class="form-actions mt-4">
              <button type="submit" class="btn-profile-save" [disabled]="isSavingProfile">
                <span *ngIf="!isSavingProfile"><i class="bx bx-save"></i> Save Changes</span>
                <span *ngIf="isSavingProfile" class="btn-spinner-wrapper">
                  <span class="btn-spinner"></span> Saving...
                </span>
              </button>
              <button type="button" class="btn-profile-cancel" (click)="toggleEditMode(false)" [disabled]="isSavingProfile">
                Cancel
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>

    <!-- ORDERS TAB -->
    <div *ngIf="activeTab === 'orders' && !isLoadingProfile" class="animate-fade-in">
      <div class="orders-section-card">
        <app-order-summery></app-order-summery>
      </div>
    </div>

    <!-- PASSWORD TAB (SECURITY) -->
    <div *ngIf="activeTab === 'password' && !isLoadingProfile" class="animate-fade-in">
      <div class="dashboard-card security-card">
        <div class="form-header">
          <h4>Change Account Password</h4>
          <p>Provide your current password and choose a secure new password.</p>
        </div>

        <form (ngSubmit)="changePassword()" class="custom-form">
          <div class="row">
            <div class="col-md-12 mb-3">
              <label class="form-label-custom">Current Password</label>
              <div class="input-icon-wrapper" [class.error]="passwordErrors.old">
                <i class="bx bx-lock-alt input-icon"></i>
                <input type="password" [(ngModel)]="password.old" name="old" class="form-control-custom" placeholder="Enter Current Password">
              </div>
              <span class="field-error" *ngIf="passwordErrors.old">{{ passwordErrors.old }}</span>
            </div>

            <div class="col-md-12 mb-3">
              <label class="form-label-custom">New Password</label>
              <div class="input-icon-wrapper" [class.error]="passwordErrors.new">
                <i class="bx bx-key input-icon"></i>
                <input type="password" [(ngModel)]="password.new" name="new" class="form-control-custom" placeholder="Enter New Password (min. 6 characters)">
              </div>
              <span class="field-error" *ngIf="passwordErrors.new">{{ passwordErrors.new }}</span>
            </div>

            <div class="col-md-12 mb-3">
              <label class="form-label-custom">Confirm New Password</label>
              <div class="input-icon-wrapper" [class.error]="passwordErrors.confirm">
                <i class="bx bx-check-shield input-icon"></i>
                <input type="password" [(ngModel)]="confirmNewPassword" name="confirm" class="form-control-custom" placeholder="Confirm New Password">
              </div>
              <span class="field-error" *ngIf="passwordErrors.confirm">{{ passwordErrors.confirm }}</span>
            </div>
          </div>

          <div class="form-actions mt-4">
            <button type="submit" class="btn-profile-save security-btn" [disabled]="isChangingPassword">
              <span *ngIf="!isChangingPassword"><i class="bx bx-shield-quarter"></i> Update Password</span>
              <span *ngIf="isChangingPassword" class="btn-spinner-wrapper">
                <span class="btn-spinner"></span> Updating...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>